import type { Control, FieldErrors, UseFormSetValue, UseFormTrigger, UseFormWatch } from 'react-hook-form';
import type { FlowFormData } from '../../validations/flowForm';
import { FlowNameStep } from './steps/FlowNameStep';
import { TriggerSelectionStep } from './steps/TriggerSelectionStep';
import { ProductSelectionStep } from './steps/ProductSelectionStep';
import { DateTimeStep } from './steps/DateTimeStep';
import { AudienceStep } from './steps/AudienceStep';
import { FLOW_TRIGGER } from '../../constants/flowTriggers';

interface StepRendererProps {
    currentStep: number;
    control: Control<FlowFormData>;
    errors: FieldErrors<FlowFormData>;
    setValue: UseFormSetValue<FlowFormData>;
    watch: UseFormWatch<FlowFormData>;
    trigger: UseFormTrigger<FlowFormData>;
    selectedTrigger: string;
    recipientCount: number;
    hasSelectedTags: boolean;
    onOpenModal: () => void;
    onDeleteAudience: () => void;
}

export const StepRenderer = ({
    currentStep,
    control,
    errors,
    setValue,
    watch,
    trigger,
    selectedTrigger,
    recipientCount,
    hasSelectedTags,
    onOpenModal,
    onDeleteAudience,
}: StepRendererProps) => {
    const isDateTriggerActive = selectedTrigger === FLOW_TRIGGER.TIME;

    switch (currentStep) {
        case 1:
            return <FlowNameStep control={control} errors={errors} />;

        case 2:
            return <TriggerSelectionStep control={control} errors={errors} />;

        case 3:
            if (isDateTriggerActive) {
                return (
                    <DateTimeStep
                        control={control}
                        errors={errors}
                        setValue={setValue}
                        watch={watch}
                        trigger={trigger}
                    />
                );
            }
            return <ProductSelectionStep control={control} errors={errors} selectedTrigger={selectedTrigger} />;

        case 4:
            if (isDateTriggerActive) {
                return (
                    <AudienceStep
                        recipientCount={recipientCount}
                        hasSelectedTags={hasSelectedTags}
                        onOpenModal={onOpenModal}
                        onDeleteAudience={onDeleteAudience}
                    />
                );
            }
            return null;

        default:
            return null;
    }
};
